import * as React from 'react';
import { ModalOverflow, ModalContent } from './ProductExcludedModalStyle';
import withCountryCode from '../RoutesHoc/RoutesHoc';
import Button from '../UI/Button';
import Row from '../UI/Row';

const ProductExcludedModal: React.ComponentType<{
  buildUrlWithCountry: (route?: string) => string;
  category: string;
  categoryPath: any;
}> = ({ category, categoryPath, buildUrlWithCountry }) => (
  <>
    <ModalContent data-cy="modal-product-excluded">
      <div>
        <Row justifyContent="center" margin="0 0 10px">
          Sorry, this item is not available in your region.
        </Row>
        <Row justifyContent="center" style={{ textAlign: 'center' }}>
          Continue discovering italist's luxury fashion offerings
        </Row>
        <Row justifyContent="center">
          or browse our&nbsp;
          <a href={buildUrlWithCountry()} style={{ textDecoration: 'underline' }}>
            homepage
          </a>
          .
        </Row>
        <Row justifyContent="center" margin="25px 0 0">
          <Button
            backgroundColor="#000000"
            border="none"
            borderRadius="2px"
            color="#FFFFFF"
            data-cy="button-product-excluded"
            fontSize="15px"
            height="40px"
            onClick={() => {
              window.location.href = buildUrlWithCountry(`/${categoryPath.ancestors}/${categoryPath.category_id}`);
            }}
            type="submit"
            width="290px"
          >
            SHOP {category.toUpperCase()}
          </Button>
        </Row>
      </div>
    </ModalContent>
    <ModalOverflow />
  </>
);

export default withCountryCode(ProductExcludedModal);
